import React from 'react';
import { Content, Loader, Table } from 'rsuite';
// @ts-ignore
import { useListaRenegociacaoProdutosMaisCaros } from '../../../hooks/useListaRenegociacaoProdutosMaisCaros.tsx';
import CurrencyFormat from 'react-currency-format';
import { HoverTooltip } from '../../../../../components/HoverTooltip';
const { Column, HeaderCell, Cell } = Table;

type RowData = {
  productId: string;
  description: string;
  avg_average_competitivity_retail: string;
  count: number;
};

const columns = [
  {
    align: 'left',
    headerCell: 'Produto',
    dataKey: 'productId',
  },
  {
    align: 'left',
    headerCell: 'Descrição',
    dataKey: 'description',
    flexGrow: 2,
  },
  {
    align: 'left',
    headerCell: 'Competitividade',
    dataKey: 'avg_average_competitivity_retail',
    width: 80,
  },
  {
    align: 'right',
    headerCell: 'Itens',
    dataKey: 'count',
  },
  // @ts-ignore
] as Column<RowData>[];

export const ListaRenegociacaoProdutosMaisCaros: React.FC = () => {
  const { data, isLoading } = useListaRenegociacaoProdutosMaisCaros();

  const competitividadeColor = (value: number) => {
    switch (true) {
      case value > 145:
        return '#F2942380';

      case value > 135 && value <= 144.99:
        return '#F2942366';

      case value > 125 && value <= 134.99:
        return '#F294234D';

      case value > 115 && value <= 124.99:
        return '#F2942333';

      case value > 105 && value <= 114.99:
        return '#F294231A';

      default:
        break;
    }
  };

  if (isLoading)
    return (
      <Content className="componente-tabela-loading">
        <Loader center />
      </Content>
    );

  if (!data || !data.length)
    return (
      <Content className="componente-tabela">
        <h2>Lista de renegociação: produtos mais caros</h2>
        <p>Produtos mais caros comparados aos seus concorrentes</p>
        <div className="sem-dados">
          <h3>Sem dados para essa análise</h3>
          <p>Revise os filtros e tente novamente</p>
        </div>
      </Content>
    );

  return (
    <Content className="componente-tabela">
      <h2>Lista de renegociação: produtos mais caros</h2>
      <p>Produtos mais caros comparados aos seus concorrentes</p>
      <div className="table-container">
        <Table data={data} height={368} rowHeight={32}>
          {columns.map((column, index) => (
            <Column key={index} {...column}>
              <HeaderCell className="header-tabela">
                {column.dataKey === 'avg_average_competitivity_retail' ? (
                  <HoverTooltip placement="bottom" text={column.headerCell} />
                ) : (
                  <span>{column.headerCell}</span>
                )}
              </HeaderCell>
              {column.dataKey === 'avg_average_competitivity_retail' ? (
                <Cell dataKey={column.dataKey}>
                  {(rowData: RowData) =>
                    rowData.avg_average_competitivity_retail ? (
                      <div
                        className="linha-tabela"
                        style={{
                          background: competitividadeColor(Number(rowData.avg_average_competitivity_retail.replace(',', '.'))),
                        }}
                      >
                        <CurrencyFormat
                          className="currency"
                          fixedDecimalScale
                          decimalScale={2}
                          value={rowData.avg_average_competitivity_retail}
                          displayType="text"
                          suffix="%"
                          decimalSeparator=","
                          thousandSeparator="."
                        />
                      </div>
                    ) : (
                      '--'
                    )
                  }
                </Cell>
              ) : (
                <Cell dataKey={column.dataKey}>{(rowData: RowData) => <div className="linha-tabela">{rowData[column.dataKey] || '--'}</div>}</Cell>
              )}
            </Column>
          ))}
        </Table>
      </div>
    </Content>
  );
};
